import { css } from '@emotion/core'
import styled, { Theme, ThemeProps } from '@themes/theme'
import { UserPickBannerH } from '@views/BettingHistory/BettingHistoryListItem/index.style'
import { CloseBtnStyle } from '@styles/button.style'


// 새로운 모달 공통 스타일
export const AdvDialogStyle = (theme: Theme) => css`

  // 초기화 작업
  .am-modal-content {
    padding-top: 14px;
    background: ${theme.color.modalBg};
    border-radius: 16px;
    .am-modal-header {
      padding: 6px 0 10px;
      .am-modal-title {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 2rem;
        font-size: ${theme.font.large};
        color: ${theme.color.modalTxt};
        svg, img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
    }
    .am-modal-body {
      padding: 0 14px;
      overflow: visible !important; /* 아이폰에서 뒷배경이 앞에 위치하는 현상 해결 */

      .modal-body-txt {
        font-size: ${theme.font.medium};
        font-weight: ${theme.fontW.medium};
        color: ${theme.color.modalTxt};
      }
    }
  }
  // 컨텐츠 양옆에 padding이 없는 경우
  &.no-padding {
    .am-modal-body {
      padding: 0;
    }
  }

  // 큰 사이즈
  &.big-size {
    width: calc(100vw - 36px);
    max-width: 400px;
    .am-modal-header {
      padding: 6px 0 10px;
      .am-modal-title {
        line-height: 2rem;
      }
    }
    .am-modal-body {
      padding: 0;
    }
    &.pc {
      width: 324px;
    }

  }
  // 중간 사이즈
  &.middle-size {
    // 임시 너비
    width: calc(100vw - 90px);
    max-width: 350px;
  }
  // 작은 사이즈
  &.small-size {
    width: calc(100vw - 114px);
    max-width: 300px;
    .modal-body-txt {
      display: flex;
      justify-content: center;
      padding: 13px 0 10px;
      line-height: 1.6rem;
      &:not(:first-of-type) {
        padding-top: 0;
        margin-top: -25px;
      }
    }
    &.pc {
      width: 246px;
    }
  }
  &.none {
    width: 0;
  }
  // 타이틀에 이미지가 들어가는 경우
  &.icon-tit {
    .am-modal-title {
      &--img {
        width: 20px;
        height: auto;
        margin-right: 6px;
        transform: translateY(-10%);
        // 경기 변경 리그 엠블럼
        img.league-ico {
          width: inherit;
          height: auto;
          max-height: 20px;
        }
      }
      &--txt {
        font-size: ${theme.font.large};
        color: ${theme.color.modalTxt};
      }
      &--point {
        &--blue {
          font-size: ${theme.font.large};
          color: ${theme.color.secondaryBg};
        }
      }
    }
  }
  // 타이틀 없이 내용이 좌우로 꽉차보이는 모달
  &.box-type {
    .am-modal-content {
      padding-top: 0; /* 기존: 18px */
      background: none;
      border-radius: 16px;
      .am-modal-header {
        padding: 24px 0 10px;
        background: ${theme.color.themeTxt};
      }
      .am-modal-body {
        padding: 0;
      }
      .adv-dialog-btn-wrap {
        padding: 0;
        .single-btn {
          width: 100%;
          height: 50px;
          background: ${theme.color.subBg};
          border-radius: 0 0 16px 16px;
          color: ${theme.color.themeTxt};
        }
      }
    }
    &.white-btn {
      .am-modal-content .adv-dialog-btn-wrap .single-btn {
        color: ${theme.color.modalTxt};
        background: ${theme.color.white};
      }
    }
    .am-modal-contents {
      padding: 14px 14px 18px;
      background: ${theme.color.themeTxt};
      &, * {
        color: ${theme.color.modalTxt};
      }
    }
  }
  // 캐릭터 모달 (모달 틀을 벗어나는 형태)
  &.character-popup {
    .am-modal-content {
      overflow: visible;
    }
  }
  // 하단 버튼이 없는 모달
  &.no-btn {
    .adv-dialog-btn-wrap {
      display: none;
    }
  }
  &.white-dialog:not(.chat .full-modal .event) {
    .am-modal-content, .am-modal-header {
      background: ${theme.color.themeTxt};
    }
  }
  // 채팅 라이브스코어 타임라인 팝업 모달
  &.live-score-timeline {
    width: calc(100vw - 18px);
    border-radius: 12px;
    position: absolute;
    top: 0;
    box-shadow: 0 3px 6px #00000018;
    .dialog-bg {
      background: transparent;
      top: 0;
    }
    .adv-dialog-btn-wrap {
      width: 38px;
      height: 38px;
      position: absolute;
      top: 2px;
      right: 2px;
      .single-btn {
        width: 100%;
        height: 100% !important;
        background: transparent !important;
        color: transparent;
        border-radius: 0 !important;
        transform: rotate(45deg);
        &::before, &::after {
          content:'';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: ${theme.color.modalSubBg};
          border-radius: 1px;
        }
        &::before {
          width: 19px;
          height: 1.5px;
        }
        &::after {
          width: 1.5px;
          height: 19px;
        }
      }
    }
    .timeline--table--basketball::before {
      bottom: 10px;
    }
  }
  &.new-middle-size {
    width: calc(100vw - 90px);
    max-width: 350px;
    .am-modal-content {
      background: ${theme.color.themeTxt};
      .am-modal-header {
        padding: 20px 0 28px !important;
        .am-modal-title {
          font-size: ${theme.font.largeNum};
          font-weight: ${theme.fontW.bold};
        }
      }
      .am-modal-body {
        .modal-body-txt {
          font-size: ${theme.font.large};
          color: ${theme.color.modalSubTxt};
        }
      }
      .adv-dialog-btn-wrap {
        padding: 37px 0 14px;
        .choice-btn {
          width: 117px;
          height: 40px;
          border-radius: 8px;
          background: ${theme.color.modalSubBg};
          color: ${theme.color.modalTxt};
          font-size: ${theme.font.large};
          font-weight: ${theme.fontW.bold};
          line-height: 42px;
          &.positive {
            background: ${theme.color.subBg};
            color: ${theme.color.themeTxt};
            margin-left: 8px;
          }
        }
      }
    }
  }
  &.new-big-size {
    width: calc(100vw - 40px);
    max-width: 400px; 
    .am-modal-content {
      background: ${theme.color.themeTxt};
      .am-modal-header {
        padding: 20px 0 28px !important;
        .am-modal-title {
          font-size: ${theme.font.largeNum};
          font-weight: ${theme.fontW.bold};
        }
      }
      .am-modal-body {
        .modal-body-txt {
          font-size: ${theme.font.large}; 
          color: ${theme.color.modalSubTxt};
        }
      }
      .adv-dialog-btn-wrap {
        padding: 37px 0 12px;
        .choice-btn {
          width: 145px;
          height: 44px;
          border-radius: 8px;
          background: ${theme.color.modalSubBg};
          color: ${theme.color.modalTxt};
          font-size: ${theme.font.large};
          font-weight: ${theme.fontW.bold};
          line-height: 42px;
          &.positive {
            background: ${theme.color.subBg};
            color: ${theme.color.themeTxt};
            margin-left: 8px;
          }
        }
      }
    }
    &.checkbox {
      .ant-checkbox-inner, .ant-checkbox-checked::after {
        width: 18px;
        height: 18px;
        border-radius: 50%;
      }
      .ant-checkbox-checked .ant-checkbox-inner {
        background: ${theme.color.accordion2} !important;
        border-color: ${theme.color.accordion2} !important;
      }
    }
    &.disabled {
      .adv-dialog-btn-wrap {
        .choice-btn {
          &.positive {
            border: 1px solid ${theme.color.modalSubBg2};
            background: ${theme.color.TP};
            color: ${theme.color.modalSubBg2};
            margin-left: 8px;
          }
        }
      }
    }
  }
  // 하단 슬라이드 모달
  &.new-slide-type {
    width: 100%;
    height: auto !important;
    position: absolute;
    bottom: 0;
    .am-modal-content {
      padding: 30px 20px 14px;
      border-radius: 16px 16px 0 0;
      background: ${theme.color.themeTxt};
      .am-modal-header { 
        padding: 0 0 30px;
        .am-modal-title {
          flex-wrap: wrap;
          font-size: ${theme.font.largeNum} !important;
          font-weight: ${theme.fontW.bold};
          .sub-tit {
            margin-top: 2px;
            width: 100%;
            font-size: ${theme.font.medium};
            font-weight: ${theme.fontW.medium};
            color: ${theme.color.modalgray};
          }
        }
      }
      .am-modal-body {
        padding: 0;
        .line {
          display: block;
          width: 100%;
          height: 1px;
          margin: 8px auto 12px;
          background: ${theme.color.modalBg};
        }
        .adv-dialog-btn-wrap {
          display: flex;
          flex-wrap: nowrap;
          .choice-btn {
            width: calc(100% - 14px / 2);
            height: 45px;
            border-radius: 6px;
            background: ${theme.color.modalSubBg};
            color: ${theme.color.modalTxt};
            font-size: ${theme.font.large};
            font-weight: ${theme.fontW.bold};
            line-height: 42px;
            &.positive {
              background: ${theme.color.subBg};
              color: ${theme.color.themeTxt};
              margin-left: 8px;
            } 
          }
        }
        .single-btn {
          width: 100%;
          height: 45px;
          border-radius: 6px;
          background: ${theme.color.accordion2};
          color: ${theme.color.themeTxt};
          font-size: ${theme.font.large};
          font-weight: ${theme.fontW.bold};
        }
      }
    }
    &.disabled {
      .adv-dialog-btn-wrap {
        .choice-btn {
          &.positive {
            transition: all .3s;
            border: 1px solid ${theme.color.modalSubBg2} !important;
            background: ${theme.color.TP} !important;
            color: ${theme.color.modalSubBg2} !important;;
          }
        }
      }
    }
    &.title-only { // 타이틀만 있는 슬라이드 팝업(베팅 완료 팝업)
      .am-modal-title {
        margin: 20px 0 40px;
      }
    }
  }
  &.match-up-modal {
    .match-up-modal-btn {
      border-radius: 26px 26px 0 0;
      overflow: hidden;
    }
    .am-modal-content {
      padding: 0;
      border-radius: 26px 26px 0 0;
      background: ${theme.color.white};
      .am-modal-body {
        overflow: hidden !important;
      }
    }
  }
  // 업로드 이미지 풀팝업 스타일
  &.image-full-popup {
    position: static;
    width: fit-content;
    height: auto;
    border-radius: 0;
    > * {
      border-radius: 0;
      padding: 0;
      position: static;
    }
    .am-modal-body {
      padding: 0;
    }
    .am-modal-content {
      background: ${theme.color.TP};
      overflow: visible;
    }
    .adv-dialog-btn-wrap {
      width: 100%;
      height: 42px;
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0;
      .single-btn {
        ${CloseBtnStyle};
        position: relative;
        top: initial;
        right: initial;
        width: 42px;
        height: 42px;
        color: ${theme.color.TP};
        border: 1.5px solid ${theme.color.themeTxt} !important;
        box-shadow: 0 2px 3px #00000040, inset 0 2px 3px #00000040;
        &::before {
          box-shadow: 1px 1px 2px #00000033;
        }
        &::after {
          box-shadow: -1px 1px 2px #00000033;
        }
      }
    }
    .dialog-bg {
      background-color: rgba(0, 0, 0, 0.9);
    }
    &.pc {
      max-width: initial !important;
    }
  }
  // 공유 베팅내역 팝업 스타일 - [이슈링크](https://task.zempublic.co.kr/view.php?id=9756)
  &.share-betting-popup {
    .am-modal-body {
      > div:not(.adv-dialog-btn-wrap):not(.dialog-bg) {
        max-height: calc(85vh - 109px - env(safe-area-inset-top) - env(safe-area-inset-bottom));
      }
      .pc-shared-betting-list-wrap {
        max-height: calc(60vh - 109px) !important;
      }
    }
  }
  // 리그필터 팝업 - 확인버튼 영역을 넓히기 위한 스타일
  &.league-filter {
    .am-modal-content {
      overflow: visible;
      .am-modal-body {
        border-radius: 16px 16px 0 0;
      }
      .adv-dialog-btn-wrap {
        .single-btn {
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            width: 100%;
            height: calc(100% + 20px);
          }
        }
      }
    }
  }
`

export const AdvDialogBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  height: auto;
  padding: 14px 0;
  .single-btn {
    width: 162px;
    height: 30px;
  }
  .choice-btn {
    width: 101px;
    height: 30px;
    &.positive {
      margin-left: 16px;
    }
  }
`
export const CommonModalListWrapStyle = (props: ThemeProps) => css`
  max-height: 356px;
  padding: 3px 6px;
  overflow: auto;
  background: ${props.theme.color.modalSubTxt};
`
export const CommonModalListItemStyle = (props: ThemeProps) => css`
  margin-bottom: 3px;
  border-radius: 6px;
  overflow: hidden;
  background: ${props.theme.color.modalBg};
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const AdvSlideUpModalStyle = (theme: Theme) =>  css`
  &.new-slide-modal.short-top.am-modal-popup {
    .am-modal-content {
      padding: 18px 14px 13px;
      .am-modal-header {
        .am-modal-title {
          line-height: 2rem;
          font-size: ${theme.font.title};
          .sub-tit {
            display: block;
            color: ${theme.color.modalSubTxt};
          }
        }
      }
    }
  }
  .one-bottom-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: 9px;
    svg {
      width: 14px;
      margin-right: 5px;
    }
  }
  &.slide-up {
    .am-modal-content {
      padding: 30px 14px 14px;
      background: ${theme.color.themeTxt};
      .am-modal-body {
        overflow: visible; /* 닫을 때 버벅이는 원인 */
      }
    }
  }
`
export const SlideUpModalTitStyle = (theme:Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${theme.font.title};
  font-weight: ${theme.fontW.bold};
  color: ${theme.color.mainBg};
  svg {
    width: 18px;
    margin: 0 5px;
  }
`
// 베팅슬립 - 베팅내역 말풍선 모달
export const BubblePopupStyle = (theme:Theme) => css`
  &.full-modal.am-modal-popup {
    .am-modal-content {
      overflow:auto;
      .am-modal-body {
        height: calc(100% - 84px);
      }
      .list-view-section-body {
        padding-bottom: 0;
      }
      .full-modal.button-wrap {
        bottom: 83px;
        padding: 0 14px;
      }
    }
    .betting-history-wrap {
      position: relative;
      top: 0;
      height: 100%;
      .am-list.am-list-view-scrollview {
        height: calc(100% - (175px + ${UserPickBannerH} - 15px));
        .react-reveal:last-child{
          padding-bottom: 15px;
        }
      }
      // 베팅내역 상단 배너 없을 경우
      &.no-banner {
        .am-list.am-list-view-scrollview {
          height: calc(100% - 175px);
          .react-reveal:last-child{
            padding-bottom: 0;
          }
        }
      }
    }
  }
  // 배팅내역 배너삽입으로 인해 위치 변경
  .is-bubble-bottom{
    .refresh-btn.full-modal{
      top: 97px !important;
    }
  }
  .bubble-bottom-btn-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 14px;
    width: 100%;
    height: 84px;
    background: ${theme.color.themeTxt};
    .bubble-tail {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 20px;
      background: ${theme.color.mainBg};
      border-radius: 0 0 16px 16px;
      &::before {
        content: '';
        display: block;
        position:absolute;
        bottom: -10px;
        left: 25%;
        border-top: 5px solid ${theme.color.mainBg};
        border-bottom: 5px solid transparent;
        border-right: 5px solid transparent;
        border-left: 5px solid  transparent;
      }
    }
    .bubble-btn {
      position: absolute;
      bottom: 14px;
      left: 26.5%;
      transform: translateX(-50%);
      width: 40px;
      height: 40px;
      border-radius: 50px;
      background: #b7b7b7;
      color: transparent;
      .x-ico {
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        width: 20px;
        height: 20px;
        &::before, &::after {
          content:'';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: ${theme.color.themeTxt};
        }
        &::before {
          width: 100%;
          height: 1.5px;
        }
        &::after {
          width: 1.5px;
          height: 100%;
        }
      }
    }
  }
`
export const SpotsQuickMenuList = styled.div`
  .quick-menu-list {
    margin-bottom: 10px;
    border-bottom: 1px solid ${props => props.theme.color.modalBg};
    &--item {
      margin-bottom: 10px;
    }
  }
  .quick-btn {
    display: flex;
    align-items: center;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    background: ${props => props.theme.color.modalBg};
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
    border-radius: 7px;
    overflow: hidden;
    &.disabled {
      svg {
        width: 12px;
        margin-right: 7px;
      }
    }
    &--img {
      width: 14px;
      height: auto;
      margin-right: 7px;
    }
    &--input {
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 110%;
      height: 130%;
      line-height: 999;
      text-indent: 999px;
      overflow: hidden;
      color: transparent;
      opacity: 0;
    }
  }

  &.message-quick-list {
    .quick-menu-list {
      margin-bottom: 0;
      border-bottom: none;
      &--item:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`
export const QuickMessageModal = (theme:Theme) => css`
  &.quick-message.am-modal.am-modal-transparent {
    position: relative;
    width: calc(100vw - 50px) !important;
    max-width: 350px;
    height: auto;
    margin-top: -10vh;
    .am-modal-content {
      border-radius: 12px;
      overflow: visible;
      background: ${theme.color.themeTxt};
      box-shadow: 3px 3px 12px rgba(0, 0, 0, .6);
      height: 508px;
      .am-modal-body {
        padding: 0 21px;
        overflow: visible !important; /* 아이폰에서 뒷배경이 앞에 위치하는 현상 해결 */
      }
      .modal-bottom-btn {
        bottom: -66px;
      }
    }
    &.is-betting-history {
      .am-modal-content {
        height: 222px;
      }
      &.is-attached-url {
        .am-modal-content {
          height: 253px;
          .attached-link {
              transform: translateY(-8px);
          }
        }
      }
    }
  }

`
// 중앙에 뜨는 선택 모달
export const SelectTypeModal = styled.div`
  padding: 0 18px 18px;
  .select-type-btn {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    line-height: 1.8rem;
    margin-bottom: 6px;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
    background: ${props => props.theme.color.modalBg};
    border-radius: 6px;
    .sub-txt {
      color: ${props => props.theme.color.modalSubTxt};
    }
  }

  &.setting-limit {
    .select-type-btn {
      flex-flow: row;
      height: 70px;
      img {
        width: 40px;
        height: auto;
        margin-right: 8px;
        margin-left: -30px;
        transform: translateZ(0) rotate(.001deg);
        image-rendering: -webkit-optimize-contrast;
      }
    }
  }
`
// 이벤트 모달 (틀이 없는 모달)
export const EventModalStyle = css`
  &.am-modal.event {
    .am-modal-content {
      border-radius: 0;
    }
    .am-modal-body {
      padding: 0;
    }
    &.pc {
      .am-modal-body {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`
export const FullPopupStyle = (theme:Theme) => css`
  .am-modal-content {
    padding: 0 !important;
    border-radius: 0 !important;
  }
  .am-modal-body {
    padding: 0 !important;
    margin: 0 !important;
    height: 100% !important;
    text-align: left;
  }
`
